import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import {
  LsAccountingService,
  LsAccountingLink
} from '../ls-accounting.service';

@Component({
  selector: 'ls-tasks-overview',
  templateUrl: './ls-accounting-setup.component.html',
  styleUrls: ['./ls-accounting-setup.component.scss']
})
export class LsAccountingSetupComponent {
  lsAccountingLink$: Observable<LsAccountingLink>;

  constructor(private lsAccountingService: LsAccountingService) {
    this.lsAccountingLink$ = this.lsAccountingService.getMagicLink();
  }

  public linkAccount(onboardingUrl: string) {
    window.location.assign(onboardingUrl);
  }
}
